<div nz-row nzType="flex">
  <div nz-col nzSpan="6">
    <div class="formname">{{ formTitle }}</div>
  </div>

  <div nz-col nzSpan="18" style="display: flex; justify-content: flex-end">
    <form nz-form [nzLayout]="'inline'">
      <nz-form-item>
        <button nz-button [nzType]="isFilterApplied" (click)="showFilter()">
          <i nz-icon nzType="filter"></i>
        </button>
      </nz-form-item>

      <nz-form-item>
        <nz-input-group nzSearch [nzAddOnAfter]="suffixIconButton">
          <input type="text" name="search" autocomplete="off" nz-input placeholder="Search Records"
            [(ngModel)]="searchText" (keydown.enter)="onEnterGetAllProjects()" />
        </nz-input-group>

        <ng-template #suffixIconButton>
          <button nz-button name="button1" id="button1" nzType="primary" (click)="getAllProjects(true)" nzSearch>
            <i nz-icon nzType="search"></i>
          </button>
        </ng-template>
      </nz-form-item>

      <nz-form-item *ngIf="
          this.cookie.get('level') == '1' ||
          this.cookie.get('level') == '2' ||
          this.cookie.get('level') == '3'
        ">
        <button nz-button nzType="primary" (click)="add()">
          <i nz-icon nzType="plus"></i>
          New Project
        </button>
      </nz-form-item>
    </form>
  </div>
</div>

<div nz-row>
  <div nz-col nzSpan="24">
    <div class="filter {{ filterClass }}">
      <div class="filter-box">
        <form nz-form>
          <div nz-row nzGutter="16">
            <div nz-col nzSpan="14">
              <nz-form-label nzNoColon>Client Name</nz-form-label>

              <nz-input-group>
                <nz-select name="clientName" nzMode="multiple" style="width: 100%" nzShowSearch style="width: 100%"
                  [(ngModel)]="projectClientID">
                  <nz-option *ngFor="let client of projectClientList" [nzValue]="client.ID"
                    [nzLabel]="client.NAME"></nz-option>
                </nz-select>
              </nz-input-group>
            </div>

            <div nz-col nzSpan="10">
              <nz-form-label>Actions</nz-form-label><br />

              <nz-button-group nzSize="default">
                <button style="margin-right: 10px" nz-button nzType="primary" (click)="getAllProjects(true)"
                  nzJustify="end">
                  <i nz-icon nzType="filter"></i>Apply Filter
                </button>

                <button nz-button nzType="primary" (click)="clearFilter()">
                  <i nz-icon nzType="filter"></i>Clear Filter
                </button>
              </nz-button-group>
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</div>

<!-- <div nz-row>
    <div nz-col nzSpan="24">
        <nz-table 
            class="my-scroll no-wrap1" 
            nzBordered #table nzShowSizeChanger 
            [nzFrontPagination]="false"
            [nzData]="projectData" 
            [nzLoading]="loadingRecords" 
            [nzTotal]="totalRecords" 
            [(nzPageIndex)]="pageIndex"
            [(nzPageSize)]="pageSize"
            (nzQueryParams)="sort($event)">

            <thead>
                <tr>
                    <th style="text-align: center;">Edit</th>
                    <th style="text-align: center;">Map</th>
                    <th style="text-align: center;">Default</th>
                    <th style="text-align: center;">Icon</th>
                    <th style="text-align: center;" nzColumnKey="STATUS" [nzSortFn]="true">Status</th>
                    <th *ngFor="let column of columns" nzColumnKey="{{column[0]}}" [nzSortFn]="true">{{column[1]}}</th>
                    <th nzColumnKey="START_DATE" [nzSortFn]="true">Start Date</th>
                    <th nzColumnKey="END_DATE" [nzSortFn]="true">End Date</th>
                    <th style="text-align: center;" nzColumnKey="IS_ACTIVE" [nzSortFn]="true">Active</th>
                </tr>
            </thead>

            <tbody>
                <tr *ngFor="let data of table.data" style="cursor: pointer;">
                    <td style="text-align: center;"><a (click)="edit(data)"><i nz-icon nzType="edit" nzTheme="outline"></i></a></td>
                    <td style="text-align: center;"><a (click)="MapForms(data)"><i nz-icon nzType="form" nzTheme="outline" ></i></a></td>
                    <td style="text-align: center; font-size: 20px;">
                        <i nz-icon *ngIf="data.ID== defaultProjectID" [nzType]="'check-circle'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></i>
                    </td>
                    <td style="text-align: center; font-size: 20px;">
                        <i nz-icon [nzType]="data.ICON" [nzTheme]="twotone" [nzTwotoneColor]="'#52c41a'"></i>
                    </td>
                    <td style="text-align: center;">
                        <nz-tag [nzColor]="'green'" *ngIf="data.STATUS== 'A'">Active</nz-tag>
                        <nz-tag [nzColor]="'yellow'" *ngIf="data.STATUS== 'OH'">On Hold</nz-tag>
                        <nz-tag [nzColor]="'blue'" *ngIf="data.STATUS== 'C'">Completed</nz-tag>
                        <nz-tag [nzColor]="'red'" *ngIf="data.STATUS== 'CN'">Cancel</nz-tag>
                    </td>
                    <td *ngFor="let column of columns" (click)="defaultProject(data)">{{data[column[0]]}}</td>
                    <td>{{data.START_DATE | date: 'dd MMM, yyyy'}}</td>
                    <td>{{data.END_DATE | date: 'dd MMM, yyyy'}}</td>
                    <td style="text-align: center;">
                        <i nz-icon *ngIf="data.IS_ACTIVE" [nzType]="'check-circle'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#52c41a'"></i>
                        <i nz-icon *ngIf="!data.IS_ACTIVE" [nzType]="'close-circle'" [nzTheme]="'twotone'" [nzTwotoneColor]="'#f50'"></i>
                    </td>
                </tr>
            </tbody>
        </nz-table>
    </div>
</div> -->

<div style="text-align: center" *ngIf="isProjectSpinning">
  <nz-spin nzSimple></nz-spin>
</div>

<div nz-row *ngIf="!isProjectSpinning">
  <div nz-col nzSpan="8" *ngFor="let project of projectData">
    <nz-card [ngStyle]="{ border: getBorder(this.cookie.get('level'), project) }" style="padding: 10px"
      [ngClass]="project.IS_ACTIVE ? 'card_active' : 'card_deActive'" nzHoverable>
      <div (click)="openKanbanModal(project)">
        <div nz-row>
          <div nz-col nzSpan="2">
            <i style="font-size: 16px" nz-icon [nzType]="project.ICON" nzTheme="outline"></i>
          </div>

          <div nz-col nzSpan="22" style="height: 45px; overflow: hidden">
            <b style="font-size: 12px">{{ project.NAME }}</b>
          </div>

          <div nz-col nzSpan="24">
            <p style="font-size: 12px; margin-bottom: 0px">
              {{ project.START_DATE | date : "dd MMM, yyyy" }}
            </p>
            <p style="color: gray; font-size: 12px; margin-bottom: 10px">
              {{ project.PROJECT_CLIENT_NAME }}
            </p>
          </div>
        </div>
      </div>

      <div>
        <div nz-row>
          <div nz-col nzSpan="8" style="text-align: left">
            <div *ngIf="project.STATUS == 'A'">
              <nz-tag [nzColor]="'green'">&nbsp; Active &nbsp;</nz-tag>
            </div>

            <div *ngIf="project.STATUS == 'OH'">
              <nz-tag [nzColor]="'yellow'">&nbsp; On Hold &nbsp;</nz-tag>
            </div>

            <div *ngIf="project.STATUS == 'C'">
              <nz-tag [nzColor]="'blue'">&nbsp; Completed &nbsp;</nz-tag>
            </div>

            <div *ngIf="project.STATUS == 'CN'">
              <nz-tag [nzColor]="'red'">&nbsp; Cancel &nbsp;</nz-tag>
            </div>
          </div>

          <div nz-col nzSpan="8" style="text-align: center">
            <nz-tag [nzColor]="'#87d068'">&nbsp; {{ project.ABBREVATION }} &nbsp;</nz-tag>
          </div>

          <div nz-col nzSpan="8" style="text-align: right">
            <span *ngIf="
                this.cookie.get('level') == '1' ||
                this.cookie.get('level') == '2' ||
                this.cookie.get('level') == '3'
              " style="margin-right: 10px" (click)="edit(project)" nzTooltipTitle="Edit Project"
              nzTooltipPlacement="top" nz-tooltip>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"
                style="height: 16px; width: 20px; margin-top: 5px">
                <path
                  d="M490.3 40.4C512.2 62.27 512.2 97.73 490.3 119.6L460.3 149.7L362.3 51.72L392.4 21.66C414.3-.2135 449.7-.2135 471.6 21.66L490.3 40.4zM172.4 241.7L339.7 74.34L437.7 172.3L270.3 339.6C264.2 345.8 256.7 350.4 248.4 353.2L159.6 382.8C150.1 385.6 141.5 383.4 135 376.1C128.6 370.5 126.4 361 129.2 352.4L158.8 263.6C161.6 255.3 166.2 247.8 172.4 241.7V241.7zM192 63.1C209.7 63.1 224 78.33 224 95.1C224 113.7 209.7 127.1 192 127.1H96C78.33 127.1 64 142.3 64 159.1V416C64 433.7 78.33 448 96 448H352C369.7 448 384 433.7 384 416V319.1C384 302.3 398.3 287.1 416 287.1C433.7 287.1 448 302.3 448 319.1V416C448 469 405 512 352 512H96C42.98 512 0 469 0 416V159.1C0 106.1 42.98 63.1 96 63.1H192z" />
              </svg>
            </span>

            <span *ngIf="
                this.cookie.get('level') == '1' ||
                this.cookie.get('level') == '2' ||
                this.cookie.get('level') == '3'
              " (click)="MapForms(project)" nzTooltipTitle="Map Team" nzTooltipPlacement="top" nz-tooltip>
              <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512" style="
                  height: 16px;
                  width: 20px;
                  margin-top: 5px;
                  margin-right: 10px;
                ">
                <path
                  d="M512 160c44.18 0 80-35.82 80-80S556.2 0 512 0c-44.18 0-80 35.82-80 80S467.8 160 512 160zM128 160c44.18 0 80-35.82 80-80S172.2 0 128 0C83.82 0 48 35.82 48 80S83.82 160 128 160zM319.9 320c57.41 0 103.1-46.56 103.1-104c0-57.44-46.54-104-103.1-104c-57.41 0-103.1 46.56-103.1 104C215.9 273.4 262.5 320 319.9 320zM368 400c0-16.69 3.398-32.46 8.619-47.36C374.3 352.5 372.2 352 369.9 352H270.1C191.6 352 128 411.7 128 485.3C128 500.1 140.7 512 156.4 512h266.1C389.5 485.6 368 445.5 368 400zM183.9 216c0-5.449 .9824-10.63 1.609-15.91C174.6 194.1 162.6 192 149.9 192H88.08C39.44 192 0 233.8 0 285.3C0 295.6 7.887 304 17.62 304h199.5C196.7 280.2 183.9 249.7 183.9 216zM551.9 192h-61.84c-12.8 0-24.88 3.037-35.86 8.24C454.8 205.5 455.8 210.6 455.8 216c0 21.47-5.625 41.38-14.65 59.34C462.2 263.4 486.1 256 512 256c42.48 0 80.27 18.74 106.6 48h3.756C632.1 304 640 295.6 640 285.3C640 233.8 600.6 192 551.9 192zM618.1 366.7c-5.025-16.01-13.59-30.62-24.75-42.71c-1.674-1.861-4.467-2.326-6.699-1.023l-19.17 11.07c-8.096-6.887-17.4-12.28-27.45-15.82V295.1c0-2.514-1.861-4.746-4.281-5.213c-16.56-3.723-33.5-3.629-49.32 0C484.9 291.2 483.1 293.5 483.1 295.1v22.24c-10.05 3.537-19.36 8.932-27.45 15.82l-19.26-11.07c-2.139-1.303-4.932-.8379-6.697 1.023c-11.17 12.1-19.73 26.71-24.66 42.71c-.7441 2.512 .2793 5.117 2.42 6.326l19.17 11.17c-1.859 10.42-1.859 21.21 0 31.64l-19.17 11.17c-2.234 1.209-3.164 3.816-2.42 6.328c4.932 16.01 13.49 30.52 24.66 42.71c1.766 1.863 4.467 2.328 6.697 1.025l19.26-11.07c8.094 6.887 17.4 12.28 27.45 15.82v22.24c0 2.514 1.77 4.746 4.188 5.211c16.66 3.723 33.5 3.629 49.32 0c2.42-.4648 4.281-2.697 4.281-5.211v-22.24c10.05-3.535 19.36-8.932 27.45-15.82l19.17 11.07c2.141 1.303 5.025 .8379 6.699-1.025c11.17-12.1 19.73-26.7 24.75-42.71c.7441-2.512-.2773-5.119-2.512-6.328l-19.17-11.17c1.953-10.42 1.953-21.22 0-31.64l19.17-11.17C618.7 371.8 619.7 369.2 618.1 366.7zM512 432c-17.67 0-32-14.33-32-32c0-17.67 14.33-32 32-32s32 14.33 32 32C544 417.7 529.7 432 512 432z" />
              </svg>
            </span>

            <a routerLink="/roadmap" (click)="openKanbanModal(project)">
              <span nzTooltipTitle="Roadmap" nzTooltipPlacement="top" nz-tooltip>
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"
                  style="height: 16px; width: 20px; margin-top: 5px">
                  <path
                    d="M256 96C256 113.7 270.3 128 288 128C305.7 128 320 113.7 320 96V32H394.8C421.9 32 446 49.08 455.1 74.63L572.9 407.2C574.9 413 576 419.2 576 425.4C576 455.5 551.5 480 521.4 480H320V416C320 398.3 305.7 384 288 384C270.3 384 256 398.3 256 416V480H54.61C24.45 480 0 455.5 0 425.4C0 419.2 1.06 413 3.133 407.2L120.9 74.63C129.1 49.08 154.1 32 181.2 32H255.1L256 96zM320 224C320 206.3 305.7 192 288 192C270.3 192 256 206.3 256 224V288C256 305.7 270.3 320 288 320C305.7 320 320 305.7 320 288V224z" />
                </svg>
              </span>
            </a>
          </div>
        </div>
      </div>
    </nz-card>
  </div>
</div>

<div style="margin-top: 20px; text-align: center" *ngIf="noMoreProjects">
  <button *ngIf="!isProjectSpinning" type="button" nzType="primary" class="ant-btn ant-btn-primary" nz-button
    (click)="loadMoreProjects()">
    <span>Load More</span>
  </button>
</div>
<div *ngIf="drawerVisible">
  <nz-drawer [nzBodyStyle]="{
    height: 'calc(100% - 55px)',
    overflow: 'auto',
    'padding-bottom': '53px'
  }" [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="800" [nzVisible]="drawerVisible"
    [nzTitle]="drawerTitle" (nzOnClose)="drawerClose()" (nzKeyboard)="(true)">
    <div *ngIf="drawerVisible == true">
      <app-project-drawer [drawerClose]="callBackDrawerClose" [data]="projectDrawerData"
        [ShowLinkOrNot]="showWorkLogsLink"></app-project-drawer>
    </div>
  </nz-drawer>
</div>
<div *ngIf="mappingDrawerVisible">
  <nz-drawer [nzBodyStyle]="{
    height: 'calc(100% - 55px)',
    overflow: 'auto',
    'padding-bottom': '53px'
  }" [nzClosable]="true" [nzMask]="true" [nzMaskClosable]="false" [nzWidth]="1000" [nzVisible]="mappingDrawerVisible"
    [nzTitle]="mappingDrawerTitle" (nzOnClose)="mappingDrawerClose()" (nzKeyboard)="(true)">
    <app-project-mapping *ngIf="mappingDrawerVisible == true" [drawerClose]="callBackMappingDrawerClose"
      [data]="projectDrawerData" [mappingData]="projectMappingDrawerData"></app-project-mapping>
  </nz-drawer>
</div>